// adding some validations logic for login form
import { required, email, minLength } from 'vuelidate/lib/validators'

export const FORM_LOGIN_VALIDATIONS = {
  dataForm: {
    loginId: {
      required,
      email
    },
    loginPassword: {
      required,
      minLength: minLength(8)
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formLogin.js